/**
 * Transient status line shown while the orchestrator runs multi-step work
 * ("Analyse uitvoeren…", "Rapportage schrijven…"). These come from `status`
 * SSE events and are NOT persisted as chat messages — they disappear when the
 * final answer streams in.
 *
 * @param {object} props
 * @param {string} props.text - The status message to show.
 */
const StatusLine = ({ text }) => {
  if (!text) return null;
  return (
    <div className="decca-status-line" role="status" aria-live="polite">
      <span className="decca-status-spinner" aria-hidden="true" />
      <span className="decca-status-text">{text}</span>
    </div>
  );
};

export default StatusLine;
